// extracted by mini-css-extract-plugin
export default {"ticketIcon":"MqhVRVl6kftGntBoBcaX"};